export default "__VITE_ASSET__C0laF9B0__"